module.exports = __webpack_public_path__ + "static/media/logosmartyellowdots.74cea318.svg";